import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

/**
 * ProtectedRoute — Arquitetura httpOnly Cookie
 *
 * Com a migração para cookie httpOnly, o token JWT não está mais acessível ao JS.
 * A verificação de sessão ativa é feita em duas camadas:
 *
 * 1. Camada de UI (rápida, síncrona):
 *    Verifica se existem dados de usuário no sessionStorage (nome, papel).
 *    Se não existirem, redireciona para /login imediatamente.
 *
 * 2. Camada de API (real, lazy):
 *    Se o cookie expirar, a próxima requisição à API retorna 401.
 *    O interceptor do Axios em api.js detecta o 401 e redireciona para /login.
 *
 * Não fazemos mais decode manual do JWT no frontend — isso era inseguro
 * e desnecessário já que o token não fica mais exposto ao JavaScript.
 */
export default function ProtectedRoute({ children }) {
  const { isAutenticado, logout } = useAuthStore();

  useEffect(() => {
    if (!isAutenticado) {
      logout();
    }
  }, [isAutenticado, logout]);

  if (!isAutenticado) {
    return <Navigate to="/login" replace />;
  }

  return children;
}